<template>
    <div>
        test
    </div>
</template>

<script>
import ctrl from "./slide.js";
export default ctrl;
</script>